import React from "react";
import SEO from "../SEO/SEO";
import Header from "../HeaderComponent/header";
import Footer from "../FooterComponent/footer";
import Herocomponent from "./Herocomponent/Herocomponent";
import OurStory from "./Ourstory/Ourstory";
import DoctorsLegacy from "./DoctorsLegacy/DoctorsLegacy";
import BooksAwards from "./BooksAwards/BooksAwards";
import Facilities from "./Facilities/Facilities";
import "./AboutPage.css";

const AboutPage = () => {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Dr. GR Reddy Eye Hospital",
    "url": "https://www.drgrreddy.com/about",
    "mainEntity": {
      "@type": "MedicalClinic",
      "name": "Dr. GR Reddy Eye Hospital",
      "founder": {
        "@type": "Person",
        "name": "Dr. GR Reddy"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Opp. Bus Depot, Ambedkar Nagar",
        "addressLocality": "Tadepalligudem",
        "addressRegion": "Andhra Pradesh",
        "postalCode": "534101",
        "addressCountry": "IN"
      },
      "telephone": "+91-9701434106"
    }
  };

  const aboutKeywords = [
    "Dr GR Reddy Eye Hospital",
    "Dr GR Reddy Tadepalligudem",
    "GR Reddy Eye Doctor",
    "GR Reddy Ophthalmologist",
    "GR Reddy Eye Specialist",
    "GR Reddy Hospital Tadepalligudem",
    "GR Reddy Eye Clinic Tadepalligudem",
    "GR Reddy Eye Care Tadepalligudem",
    "GR Reddy Eye Centre Tadepalligudem",
    "GR Reddy Eye Hospital Address",
    "GR Reddy Eye Hospital Location",
    "GR Reddy Eye Hospital Contact Number",
    "GR Reddy Eye Hospital Doctors",
    "GR Reddy Eye Hospital Reviews",
    "Experienced Eye Doctor in Tadepalligudem",
    "Experienced Ophthalmologist in Tadepalligudem",
    "Senior Eye Doctor in Tadepalligudem",
    "Senior Eye Specialist Near Me",
    "Trusted Eye Hospital in Tadepalligudem",
    "Trusted Eye Doctor in Tadepalligudem",
    "Reputed Eye Hospital in Tadepalligudem",
    "Leading Eye Doctor in Tadepalligudem",
    "Top Eye Specialist in Tadepalligudem",
    "Best Eye Doctor in West Godavari",
    "Eye Doctor Tadepalligudem West Godavari",
    "Eye Hospital Tadepalligudem West Godavari"
  ];

  return (
    <div className="AboutPage">
      <SEO
        title="About Us - GR Reddy Eye Hospital | Tadepalligudem"
        description="Learn about the legacy of Dr. GR Reddy Eye Hospital in Tadepalligudem. Meet our experienced ophthalmologists, explore modern facilities, books, and awards dedicated to high quality vision care."
        keywords={aboutKeywords}
        canonical="https://www.drgrreddy.com/about"
        ogImage="https://www.drgrreddy.com/favicon.png"
        schemaData={aboutSchema}
      />
      <Header />
      <main className="main-content">
        <Herocomponent />
        <OurStory />
        <DoctorsLegacy />
        <BooksAwards />
        <Facilities />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;

